const getReviews = async () => {

  const count = localStorage.getItem('reviews_count');
  const refTime = new Date();
  refTime.setMinutes(refTime.getMinutes() - 5);
  if (!count || count.time < refTime) {
    try {
      const res = await fetch('https://euxq08dr7h.execute-api.us-east-2.amazonaws.com/judgeme');
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  } 
}
getReviews();